var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "router-link",
    {
      directives: [
        {
          name: "track",
          rawName: "v-track:click",
          value: {
            axId: _vm.axId,
            axType: "button"
          },
          expression: "{\n    axId: axId,\n    axType: 'button',\n  }",
          arg: "click"
        }
      ],
      class: { refer: _vm.shouldOverrideHeaderButtonForReferralOrGift },
      attrs: { to: _vm.link }
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }